<!-- src/components/TransactionTab.vue -->
<template>
  <div>
    <!-- 操作按钮行 1 -->
    <div class="search-box">
      <div class="left">
        <div class="child">
          <!-- <span class="label">业务日期：</span>
          <div class="flex flex-center">
            <el-date-picker
              v-model="searchParams.startDate"
              type="date"
              size="mini"
              clearable
              style="width: 150px;"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            />
            <span>-</span>
            <el-date-picker
              v-model="searchParams.endDate"
              clearable
              type="date"
              size="mini"
              style="width: 150px;"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            />
          </div> -->
          <DateSelect ref="dateSelect" @change="dateChange">业务日期：</DateSelect>
        </div>
        <div class="child">
          <span class="label" style="min-width:60px">单据号：</span>
          <el-input
            v-model="searchParams.purchaseNo"
            placeholder="请输入业务单号、订单号"
            style="width:180px"
            size="mini"
            clearable
          />
        </div>
        <div class="child">
          <span class="label">业务类型：</span>
          <el-select
            v-model="searchParams.billTypes"
            multiple
            collapse-tags
            style="width:200px"
            placeholder="全部"
            size="mini"
            clearable
          >
            <el-option v-for="item in billtypeList" :label="item.name" :value="item.code" :key="item.code" />
          </el-select>
        </div>
        <div class="child">
          <span class="label">对账状态：</span>
          <el-select
            v-model="searchParams.statementStatus"
            style="width:120px"
            placeholder="全部"
            size="mini"
            clearable
          >
            <el-option label="全部" :value="0" />
            <el-option label="已对" :value="1" />
            <el-option label="未对" :value="2" />
          </el-select>
        </div>
        <div class="child">
          <span class="label">结算状态：</span>
          <el-select v-model="searchParams.settledStatus" style="width:120px" placeholder="全部" size="mini" clearable>
            <el-option label="全部" :value="0" />
            <el-option label="已结清" :value="1" />
            <el-option label="未结清" :value="2" />
          </el-select>
        </div>
        <div class="child">
          <span class="label">收付类型：</span>
          <el-select v-model="searchParams.settleType" style="width:120px" placeholder="全部" size="mini" clearable>
            <el-option label="全部" :value="0" />
            <el-option label="应收" :value="1" />
            <el-option label="应付" :value="2" />
          </el-select>
        </div>
        <div class="child" style="margin-left: 12px;">
          <el-button type="primary" size="mini" @click="handleSearch1">查询</el-button>
          <el-button size="mini" @click="handleReset1">重置</el-button>
        </div>
      </div>
      <!-- <el-button type="success" size="mini" @click="handleExport1">导出</el-button> -->
    </div>
    <!-- 表格 1 -->
    <div class="table-wrap">
      <el-table
        :data="tableData1"
        border
        v-loading="loading1"
        @sort-change="sortChange"
        highlight-current-row
        @row-click="rowClick"
        stripe
        style="width:100%;"
        size="small"
        show-summary
        :summary-method="getSummaries1"
      >
        <el-table-column label="序号" width="60" align="center" type="index" fixed></el-table-column>
        <el-table-column
          prop="statementStatus"
          label="对账状态"
          align="center"
          show-overflow-tooltip
          sortable="custom"
          width="110"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.statementStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="billDate"
          label="业务日期"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="billPurchaseNo"
          label="业务单号"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="200"
        />
        <el-table-column
          prop="settleStatus"
          label="结算状态"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.settleStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="billType"
          label="业务类型"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="150"
        />
        <el-table-column
          prop="amountOut"
          label="应付"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.amountOut }}</template>
        </el-table-column>
        <el-table-column
          prop="amountIn"
          label="应收"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.amountIn }}</template>
        </el-table-column>
        <el-table-column
          prop="settleCurr"
          label="结算"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.settleCurr }}</template>
        </el-table-column>
        <el-table-column
          prop="zCurr"
          label="优惠"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.zCurr }}</template>
        </el-table-column>
        <el-table-column
          prop="noSettleCurr"
          label="欠款"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.noSettleCurr }}</template>
        </el-table-column>
        <el-table-column
          prop="invoiceType"
          label="发票类型"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="140"
        />
        <el-table-column
          prop="remoteOrderNo"
          label="订单号"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="businessMan"
          label="业务员"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="createdBy"
          label="制单人"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="createDate"
          label="制单时间"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="180"
        />
      </el-table>
    </div>

    <!-- 分页 1 -->
    <div style="margin-top:12px;text-align:right;margin-bottom:16px;">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1"
        :page-size="searchParams.pageSize"
        :current-page.sync="searchParams.page"
        @size-change="
          s => {
            searchParams.pageSize = s;
            getList();
          }
        "
        @current-change="
          p => {
            searchParams.page = p;
            getList();
          }
        "
      />
    </div>

    <!-- 操作按钮行 2 -->
    <div class="search-box" v-show="false">
      <div class="left">
        <div class="child">
          <span class="label">商品明细：</span>
          <div class="parts-search">
            <el-input
              ref="PartsSearchInput"
              v-model="searchParams2.keyword"
              size="mini"
              clearable
              @keyup.enter.native="partsEnter"
              @focus="focusPartsSearchInput"
              placeholder="0键/Alt+0定位、Enter查询"
            >
              <div slot="append" class="parts-search-append">
                <div @click="handleSearch2" class="parts-search-icon">
                  <i class="el-icon-search"></i>
                </div>
              </div>
            </el-input>
          </div>
        </div>
        <div class="child" style="margin-left: 12px;">
          <el-button type="primary" size="mini" @click="handleSearch2">查询</el-button>
          <el-button size="mini" @click="handleReset2">重置</el-button>
        </div>
      </div>
    </div>
    <!-- 表格 2 -->
    <div class="table-wrap" v-show="false">
      <el-table :data="tableData2" border @sort-change="sortChange2" stripe style="width:100%;" size="small">
        <el-table-column label="序号" width="60" type="index" fixed></el-table-column>
        <el-table-column
          prop="billDate"
          label="业务日期"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="billNo"
          label="业务单号"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="140"
        />
        <el-table-column
          prop="billType"
          label="业务类型"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        />
        <el-table-column
          prop="partNo"
          label="商品编码"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="partName"
          label="商品名称"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="140"
        />
        <el-table-column
          prop="price"
          label="单价"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.price }}</template>
        </el-table-column>
        <el-table-column
          prop="qty"
          label="数量"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="amount"
          label="小计"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">{{ scope.row.amount }}</template>
        </el-table-column>
        <el-table-column
          prop="amountOut"
          label="应付"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.amountOut }}</template>
        </el-table-column>
        <el-table-column
          prop="amountIn"
          label="应收"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.amountIn }}</template>
        </el-table-column>
        <el-table-column
          prop="partBrand"
          label="品牌"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="partFactory"
          label="产地"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="categoryName"
          label="商品分类"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        />
        <el-table-column
          prop="vehModel"
          label="车型"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="property"
          label="商品性质"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        />
        <el-table-column
          prop="quality"
          label="品质"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="model"
          label="规格"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="prodCode"
          label="生产码"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="130"
        />
        <el-table-column
          prop="paymentTypeName"
          label="收付类型"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="110"
        />
        <el-table-column
          prop="orderCode"
          label="订单号"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="130"
        />
        <el-table-column
          prop="invoiceType"
          label="发票类型"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="140"
        />
      </el-table>
    </div>

    <!-- 分页 2 -->
    <!-- <div style="margin-top:12px;text-align:right;">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total2"
        :page-size="pageSize2"
        :current-page.sync="currentPage2"
        @size-change="
          s => {
            pageSize2 = s;
            getList2();
          }
        "
        @current-change="
          p => {
            currentPage2 = p;
            getList2();
          }
        "
      />
    </div> -->
  </div>
</template>

<script>
import { receivePayList, receivePayDetailsList, billTypes } from "@/api/reconciliation";
import DateSelect from "@/components/DateSelect";
const dateRange = window.tool.getDateRangeByName("本月");
export default {
  name: "TransactionTab",
  components: {
    DateSelect
  },
  data() {
    return {
      searchParams: {
        purchaseNo: "",
        dateType: "", //0:下单日期；1:结算日期
        startDate: dateRange[0],
        endDate: dateRange[1],
        billTypes: [], //业务类型
        settleType: 0, //# 结算类型(0：全部；1：应收；2：应付)
        statementStatus: 0, //# 对账状态(0：全部；1：已对；2：未对)
        settledStatus: 0, //# 结算状态（0：全部；1：已结清；2：未结清）
        settleStatus: 0, //# 原结算状态（0：全部1：已结2：对账待结3：未结）
        sort: "",
        page: 1,
        pageSize: 10
      },
      searchParams2: {
        keyword: "", // # 关键字
        sort: "" //# 排序字段
      },
      tableData1: [],
      tableData2: [],
      total1: 0,
      total2: 0,
      loading1: false,
      loading2: false,
      totalInfo: {},
      billtypeList: []
    };
  },
  mounted() {
    this.getList();
    this.getBillTypes();
  },
  methods: {
    //获取来源类型
    getBillTypes() {
      billTypes().then(res => {
        this.billtypeList = res || [];
      });
    },
    dateChange(dateObj) {
      this.searchParams.startDate = dateObj.startDate;
      this.searchParams.endDate = dateObj.endDate;
    },
    focusPartsSearchInput(e) {
      e.target.select();
    },
    partsEnter() {
      this.setKeyword();
    },
    setKeyword() {
      if (!this.searchParams2.keyword || this.searchParams2.keyword.length < 2) {
        this.$message.error("关键字至少输入两位！");
        return;
      }
      this.handleSearch2();
      this.$refs.PartsSearchInput.blur();
    },
    // 表格1合计行计算方法
    getSummaries1(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const prop = column.property;
        // 需要对哪些列进行合计
        const sumFields = ["amountOut", "amountIn", "settleCurr", "zCurr", "noSettleCurr"];
        if (sumFields.includes(prop)) {
          if (prop === "zCurr") {
            sums[index] = this.totalInfo.discountAmount;
          } else if (prop === "settleCurr") {
            sums[index] = this.totalInfo.settledAmount;
          } else if (prop === "noSettleCurr") {
            sums[index] = this.totalInfo.sumNoSettleCurr;
          } else {
            sums[index] = this.totalInfo[prop];
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    sortChange2({ prop, order }) {
      if (order) {
        if (order.includes("desc")) {
          this.searchParams2.sort = `${prop}-desc`;
        } else {
          this.searchParams2.sort = `${prop}-asc`;
        }
      } else {
        this.searchParams2.sort = "";
      }
      this.getList2();
    },
    getList2() {
      this.loading2 = true;
      const params = {
        ...this.searchParams,
        ...this.searchParams2
      };
      receivePayDetailsList(params)
        .then(res => {
          this.tableData2 = res.rows || [];
          this.total2 = res.totalSize;
        })
        .catch(err => {
          this.tableData2 = [];
          this.total2 = 0;
          this.$message.error(err.message);
        })
        .finally(() => {
          this.loading2 = false;
        });
    },
    rowClick(row) {
      console.log(row);
      // this.searchParams2.id = row.id;
      // this.getList2();
    },
    sortChange({ prop, order }) {
      if (order) {
        if (order.includes("desc")) {
          this.searchParams.sort = `${prop}-desc`;
        } else {
          this.searchParams.sort = `${prop}-asc`;
        }
      } else {
        this.searchParams.sort = "";
      }
      this.getList();
    },
    getList() {
      this.loading1 = true;
      receivePayList(this.searchParams)
        .then(res => {
          console.log("list", res);
          this.tableData1 = res.rows || [];
          this.total1 = res.totalSize;
          this.totalInfo = {
            amountIn: res.amountIn,
            amountOut: res.amountOut,
            discountAmount: res.discountAmount,
            settledAmount: res.settledAmount,
            sumNoSettleCurr: res.sumNoSettleCurr,
            sumPayCurr: res.sumPayCurr,
            sumReceCurr: res.sumReceCurr
          };
        })
        .catch(err => {
          this.tableData1 = [];
          this.total1 = 0;
          this.$message.error(err.message);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    handleSearch1() {
      this.searchParams.page = 1;
      this.getList();
    },
    handleReset1() {
      this.searchParams = {
        purchaseNo: "",
        dateType: "", //0:下单日期；1:结算日期
        // startDate: "",
        // endDate: "",
        billTypes: [], //业务类型
        settleType: 0, //# 结算类型(0：全部；1：应收；2：应付)
        statementStatus: 0, //# 对账状态(0：全部；1：已对；2：未对)
        settledStatus: 0, //# 结算状态（0：全部；1：已结清；2：未结清）
        settleStatus: 0, //# 原结算状态（0：全部1：已结2：对账待结3：未结）
        sort: "",
        page: 1,
        pageSize: this.searchParams.pageSize
      };
      this.$refs.dateSelect.reset();
      this.$refs.dateSelect.confirm();
      this.getList();
    },
    handleExport1() {
      this.$message.success("导出往来单据 (静态演示)");
    },
    handleSearch2() {
      this.getList2();
    },
    handleReset2() {
      this.searchParams2.keyword = "";
      this.getList();
    },
    statusTag(type) {
      const map = { done: "已对账", pending: "待对账", wait: "部分对账", cancel: "作废" };
      return map[type] || type;
    },
    statusClass(type) {
      return "tag-status " + (type || "default");
    },
    settleTag(type) {
      const map = { done: "已结算", pending: "未结算", wait: "部分结算" };
      return map[type] || type;
    },
    settleClass(type) {
      return "tag-status " + (type || "default");
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .parts-search {
  width: 250px;
  .el-input-group__append {
    padding: 0;
  }
  .parts-search-append {
    display: flex;
    .parts-search-icon,
    .parts-search-setting {
      padding: 0 10px;
      cursor: pointer;
      font-size: 18px;
    }
    .parts-search-setting {
      border-left: 1px solid #dcdfe6;
    }
  }
}
.search-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  box-sizing: border-box;
  background-color: rgba(249, 249, 249, 1);
  column-gap: 12px;
  .left {
    display: flex;
    align-items: center;
    .child {
      display: flex;
      align-items: center;
      .label {
        font-size: 14px;
        color: #555555;
        min-width: 80px;
        text-align: right;
      }
    }
  }
}
.table-wrap {
  margin-top: 4px;
  overflow-x: auto;
}
.table-wrap .el-table {
  font-size: 13px;
}
.tag-status {
  font-size: 12px;
  padding: 0 10px;
  border-radius: 12px;
  line-height: 24px;
  display: inline-block;
}
.tag-status.done {
  background: #e1f3d8;
  color: #67c23a;
}
.tag-status.pending {
  background: #fdf6ec;
  color: #e6a23c;
}
.tag-status.wait {
  background: #e9f0fc;
  color: #409eff;
}
.tag-status.cancel {
  background: #fef0f0;
  color: #f56c6c;
}
.tag-status.default {
  background: #f4f4f5;
  color: #909399;
}

// 合计行样式
.table-wrap ::v-deep .el-table__footer-wrapper {
  font-weight: bold;
  .el-table__footer td {
    background-color: #f5f7fa;
  }
}
</style>
